import { render, staticRenderFns } from "./addressbook_dropdown.vue?vue&type=template&id=fedb46b0&scoped=true"
import script from "./addressbook_dropdown.vue?vue&type=script&lang=js"
export * from "./addressbook_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedb46b0",
  null
  
)

export default component.exports